var React = require('react');

function IconOpen (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","fill":"none","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M14.5,8.5 L14.5,13.1823525 C14.5,13.9100691 13.9162615,14.5 13.182914,14.5 L1.81708601,14.5 C1.08967949,14.5 0.5,13.9162615 0.5,13.182914 L0.5,1.81708601 C0.5,1.08967949 1.09439142,0.5 1.80585884,0.5 L6.5,0.5","id":"outer-path","key":0}),React.createElement("path",{"d":"M7.5,7.5 L14.5,0.5","id":"line","key":1}),React.createElement("polyline",{"id":"arrow","points":"9.5 0.5 14.5 0.5 14.5 5.5","key":2})]));
}

IconOpen.defaultProps = {"viewBox":"0 0 15 15"};

module.exports = IconOpen;

IconOpen.default = IconOpen;
